import { camelCase, snakeCase, upperFirst } from 'scule'

export function objectToCamelCase<T>(obj: T): CamelCase<T> {
  if (typeof obj !== 'object' || obj === null) {
    return obj as CamelCase<T>
  }

  if (Array.isArray(obj)) {
    return obj.map(item => objectToCamelCase(item)) as CamelCase<T>
  }

  if (typeof obj === 'object') {
    const newObj: { [key: string]: unknown } = {}
    Object.keys(obj).forEach(key => {
      // Preserve CONSTANT_CASE keys
      const transformedKey = /^[A-Z0-9_]+$/.test(key) ? key : camelCase(key)
      newObj[transformedKey] = objectToCamelCase(obj[key as keyof T])
    })
    return newObj as CamelCase<T>
  }

  return obj
}

export function objectToSnakeCase<T>(obj: T): SnakeCase<T> {
  if (typeof obj !== 'object' || obj === null) {
    return obj as SnakeCase<T>
  }

  if (Array.isArray(obj)) {
    return obj.map(item => objectToSnakeCase(item)) as SnakeCase<T>
  }

  if (typeof obj === 'object') {
    const newObj: { [key: string]: unknown } = {}
    Object.keys(obj).forEach(key => {
      // Preserve CONSTANT_CASE keys
      const transformedKey = /^[A-Z0-9_]+$/.test(key) ? key : snakeCase(key)
      newObj[transformedKey] = objectToSnakeCase(obj[key as keyof T])
    })
    return newObj as SnakeCase<T>
  }

  return obj
}

export function stringToCamelCase(str: string) {
  return camelCase(str)
}

export function stringToSnakeCase(str: string) {
  return str.toLowerCase().replace(/\s+/g, '_')
}

export function camelToSnakeCase<T extends string>(str: T) {
  return snakeCase(str)
}

export function capitalize(str: string) {
  return upperFirst(str)
}

export function uppercase(str: string) {
  return str.toUpperCase()
}

export function lowercase(str: string) {
  return str.toLowerCase()
}
